<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-03",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 23,
      nextPage: '/questionnaire/section2/4',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/25-Immunity.png'),
        mainTitle: 'Do you often stay up late?',
        btn: [
          [
            {
              text: 'Yes',
              operation: 'add product FM-PROBI-101'
            }
          ],[
            {
              text: 'Occasionally',
            }
          ],[
            {
              text: 'No',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
